// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"96777718","422":"853b243a","484":"4646db72","551":"b70a2eda","828":"32cbabb3"}[chunkId] + ".chunk.js";
};